<template>
  <div class="d-flex mb-3 position-relative pb-2">
    <v-chip
      v-for="(question, key) in questions"
      :key="key"
      x-small
      :color="activeTab !== key ? 'default' : 'challenge'"
      class="content-tab rounded w-100 py-1 pointer-on-hover border-0"
      :class="[(key<questions.length - 1) && 'mr-1']"
      style="height: 10px"
      @click="$emit('input',key)"
    />
  </div>
</template>

<script>
export default {
  props: {
    questions: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: Number,
      required: true,
    }
  }
}
</script>
